// size 'sm' matches a btn-sm (h-8) when the toggle sits beside one
function ToggleButton({ active, onClick, children, isJoinItem = true, size = 'md', activeColor = 'black', type = 'button', disabled = false, inactiveClass = 'bg-white text-slate-700 border-slate-200 hover:bg-slate-100', ...rest }) {
  const activeClass =
    activeColor === 'dark'  ? 'bg-slate-700 text-white border-slate-700' :
    activeColor === 'muted' ? 'bg-slate-400 text-white border-slate-400' :
                              'bg-black     text-white border-black';

  const colorClass = disabled
    ? active
      ? 'bg-slate-400 text-white border-slate-400'
      : 'bg-slate-50 text-slate-400 border-slate-200'
    : active
      ? activeClass
      : inactiveClass;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={[
        isJoinItem ? 'join-item' : 'rounded-lg',
        size === 'sm' ? 'h-8' : 'h-9',
        'px-3 text-sm font-semibold border cursor-pointer transition-colors select-none focus:outline-none disabled:cursor-not-allowed',
        colorClass,
      ].join(' ')}
      {...rest}
    >
      {children}
    </button>
  );
}

export default ToggleButton;
